import { Link } from "react-router-dom";
import { categories } from "@/mocks/manga";

const quickLinks = [
  { label: "首页", to: "/" },
  { label: "漫画库", to: "/list" },
  { label: "高甜榜", to: "/list?tab=hot" },
  { label: "少女馆", to: "/list?cat=少女" },
  { label: "纯爱馆", to: "/list?cat=纯爱" },
];

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-lg text-background-50">
                <i className="ri-cup-line" aria-hidden="true"></i>
              </span>
              <span className="whitespace-nowrap font-heading text-xl text-foreground-900">
                布丁<span className="text-primary-500">漫画网</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-6 text-foreground-600">
              布丁漫画网专注甜系恋爱漫画，收录甜宠、恋爱、高甜、少女、纯爱、狗粮漫画。支持按甜度、CP、画风筛选，追更提醒、章节排序、收藏记录一站备齐。
            </p>
            <div className="mt-5 flex gap-3 text-foreground-500">
              <a href="#" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 hover:text-primary-600" aria-label="微博"><i className="ri-weibo-line"></i></a>
              <a href="#" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 hover:text-primary-600" aria-label="哔哩哔哩"><i className="ri-bilibili-line"></i></a>
              <a href="#" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 hover:text-primary-600" aria-label="微信公众号"><i className="ri-wechat-line"></i></a>
            </div>
          </div>

          <div>
            <h3 className="font-heading text-base text-foreground-900">快速导航</h3>
            <ul className="mt-4 space-y-3">
              {quickLinks.map((l) => (
                <li key={l.label}>
                  <Link to={l.to} className="text-sm text-foreground-600 hover:text-primary-600">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-base text-foreground-900">漫画分类</h3>
            <ul className="mt-4 flex flex-wrap gap-x-4 gap-y-3">
              {categories.map((c) => (
                <li key={c.name}>
                  <Link to={`/list?cat=${encodeURIComponent(c.name)}`} className="text-sm text-foreground-600 hover:text-primary-600">
                    {c.name}漫画
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 text-sm text-foreground-500 sm:flex-row">
          <p>© {new Date().getFullYear()} 布丁漫画网 · 只为甜甜的恋爱而存在</p>
          <p className="flex items-center gap-2">
            <span className="flex items-center gap-1"><i className="ri-heart-3-line text-primary-500"></i>按甜度找漫画</span>
            <span className="text-background-400">|</span>
            <span>题材与内容仅供阅读参考</span>
          </p>
        </div>
      </div>
    </footer>
  );
}